import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { useTranslation } from 'react-i18next';
import L from 'leaflet';
import 'leaflet-defaulticon-compatibility';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css';
import logo from '../assets/img/Przezroczysty_kolor.png';

const customIcon = L.divIcon({
  className: 'custom-div-icon',
  html: `<div style="background: white; border-radius: 50%; width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; overflow: hidden;">
           <img src="${logo}" style="width: 40px; height: auto;" />
         </div>`,
  iconSize: [50, 50],
  iconAnchor: [25, 50],
  popupAnchor: [0, -50],
});

const Map = () => {
  const { t } = useTranslation();
  const position = [50.0608661, 19.9493186];

  return (
    <section className='py-24'>
      <div className="text-center">
        <div className="font-tertiary uppercase text-[15px] tracking-[6px] ">
          {t("surrText")}
        </div>
        <h2 className="font-primary text-[45px] mb-4">{t("surrTitle")}</h2>
      </div>
      <MapContainer 
        center={position} 
        zoom={13} 
        style={{ height: '50vh', width: '100%' }}
        className='z-40'
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={position} icon={customIcon}>
          <Popup>
            12 Hugona Kołłątaja, Grzegórzki, 31-502 Kraków, Polska
          </Popup>
        </Marker>
      </MapContainer>
    </section>
  );
}

export default Map;
